import React from 'react'
import FileUploadedItem from './FileUploadedItem'

const FileUploadedList = ({ files }) => {
  return (
    <div className='fileUploadedList'>
        {
            files && files.length > 0 ?
                files.map((file, item) => {
                    return (
                        <FileUploadedItem
                            key={file.name + file.lastModified}
                            item={item + 1}
                            file={file}
                        />
                    )
                })
            : ''
        }
    </div>
  )
}

export default FileUploadedList